<template>
  <base-dialog
    :action="onAction"
    :action-name="'Update Plan'"
    :close="onClose"
    :title="'Edit Plan'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-text-field
        outlined
        dense
        v-model="model.nickname"
        type="text"
        hint="This won't be visible to customers, but will help you find this plan later."
        persistent-hint
        label="Plan nickname"
      />

      <v-text-field
        outlined
        dense
        v-model="model.trial_period_days"
        type="text"
        hint="Subscriptions to this plan will automatically start with a free trial of this length."
        persistent-hint
        label="Trial period"
        suffix="days"
      />
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    plan: {
      type: Object,
      default: () => ({})
    },
  },
  mounted() {
    this.model = { ...this.plan}
  },
  data() {
    return {
      model: {
        nickname: '',
        trial_period_days: 0,
      }
    }
  },
  methods: {
    ...mapActions([ 'updatePlan' ]),
    clear() {
      this.model.nickname = ''
      this.model.trial_period_days = 0
    },
    onClose() {
      this.clear()
      this.$emit('close')
    },
    onAction() {
      const payload = {
        ...this.model
      }

      return this.updatePlan(payload)
        .then(res => {
          if (!isErrorResponse(res)) {
            this.clear()
            this.$emit('action', payload)
          }
          return res
        })
    }
  }
}
</script>
